export const slbServicesSolutionsPdp = {
    servicesPdpAddToCart: {
        downloadBrochure: 'Download the Brochure'
    }
}